import React, { useCallback, useMemo } from 'react';
import Accordion from 'components/Accordion';
import DatePicker from 'components/DatePicker';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';
import useForecastPeriod from 'hooks/Meteorology/Agro/CultureIndex/Location/useForecastPeriod';

export default function Period() {
  const {
    periodStart,
    periodEnd,
    changePeriod,
    availablePeriod,
  } = useForecastPeriod();
  const closeAccordion = useMemo(
    () => buildAccordionClickFunction('culture-index-location-period'),
    [],
  );
  const changePeriodAndClose = useCallback((dates: (Date | null)[]) => {
    changePeriod(dates);
    if (dates.every((date) => date !== null)) {
      closeAccordion();
    }
  }, [changePeriod, closeAccordion]);

  return (
    <Accordion.Item eventKey="period" id="culture-index-location-period">
      <Accordion.Header>Período de previsão</Accordion.Header>
      <Accordion.Body>
        <DatePicker
          inline
          onChange={changePeriodAndClose}
          startDate={periodStart}
          endDate={periodEnd}
          includeDates={availablePeriod}
          selectsRange
        />
      </Accordion.Body>
    </Accordion.Item>
  );
}
